import axios from "axios";
import { CryptoUtils } from '../utils/crypto-utils.js';

const API_URL = process.env.REACT_APP_MASTER_API;
const AZURE_AD_URL = process.env.REACT_APP_AZURE_AD_GRAPH_URL;

export async function authenticate(userBody) {
  let url = API_URL + "/authenticate";
  console.log("in user service --- ", url);
  let response = await axios.get(url, userBody);
  return response.data;
}

export async function getUserInfo(UserID) {
  if (!(UserID.includes("@godrej.com"))) {
    UserID = UserID + "@godrej.com";
  }
  let url = AZURE_AD_URL + `/${UserID}`
  let token = sessionStorage.getItem("Azure_AD_Access_Token")
  let headers = {
    'Authorization': 'Bearer ' + token
  }
  const options = {
    method: "GET",
    headers: headers
  };
  return fetch(url, options).then(response => response.json()).catch(error => console.log(error));
}

export async function verifyAccessCode(codeObj) {
  let url = API_URL + "/verifycode";
  let response = await axios.post(url, codeObj);
  return response.data;
}

export async function getAllUsers(deptId) {
  let url = API_URL + "/alluser";
  let response = await axios.post(url, { deptId });
  return response.data;
}

export async function getActiveUser(userId) {
  let url = API_URL + "/activeuser";
  let response = await axios.post(url, userId);
  return response.data;
}

export const addNewUser = async (user) => {
  let url = `${API_URL}/adduser`;
  const response = await axios.post(url, user);
  return response.data;
};

export const deleteUser = async (user) => {
  let url = `${API_URL}/deleteuser`;
  const response = await axios.post(url, user);
  return response.data;
};

export const getAccessCriteria = async () => {
  let url = `${API_URL}/ACCESS_CRITERIA`;
  let response = await axios.get(url);
  return response.data;
};

export const getZones = async () => {
  let url = `${API_URL}/ZONE`;
  let response = await axios.get(url);
  return response.data;
};

export const getBranches = async (zoneCode = null) => {
  try {
    let url = `${API_URL}/BRANCH`;
    if (zoneCode) {
      url += `?zone=${zoneCode}`;
    }
    console.log('Fetching branches from URL:', url);
    let response = await axios.get(url);
    console.log('Branch API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error in getBranches:', error);
    throw error;
  }
};

export const getDivisions = async () => {
  let url = `${API_URL}/DIVISION`;
  let response = await axios.get(url);
  return response.data;
};

export async function getUsersForRole(roleId) {
  let url = `${API_URL}/usersforrole`;
  let reqBody = { roleId }
  const response = await axios
    .post(url, reqBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: [] };
    });
  return response.data;
}

export const getUniqueRoles = async () => {
  const deptId = sessionStorage.getItem('DeptId');
  let url = `${API_URL}/uniqueroles`;
  let response = await axios.post(url, { DeptId: deptId });
  return response.data;
};

export async function logout() {
  let url = API_URL + "/logout";
  let response = await axios.post(url, {});
  return response.data;
}